import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthService from '../services/auth.service';

const LogoutPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const performLogout = async () => {
      try {
        const userRole = AuthService.getUserRole();
        
        // Esegui logout con chiamata API appropriata
        if (userRole === 'admin') {
          await AuthService.adminLogout();
        } else {
          await AuthService.logout();
        }
        
        // Determina la rotta di redirect
        const getRedirectRoute = () => {
          // Se siamo su una rotta admin, torna al login admin
          if (location.pathname.startsWith('/admin')) {
            return '/admin/login';
          }
          
          // Per dottori e pazienti, stesso login
          return '/patient/login';
        };

        navigate(getRedirectRoute());
        
      } catch (error) {
        console.error('Errore durante il logout:', error);
        // Anche in caso di errore, redirect al login appropriato
        const fallbackRoute = location.pathname.startsWith('/admin') ? '/admin/login' : '/patient/login';
        navigate(fallbackRoute);
      }
    };

    performLogout();
  }, [navigate, location.pathname]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-purple-600 mb-4"></div>
        <p className="text-gray-600">Disconnessione in corso...</p>
      </div>
    </div>
  );
};

export default LogoutPage;